import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib/core/store';
import { createSlice } from '@reduxjs/toolkit';

export const graphSitesUiSlice = createSlice({
  name: 'graph-sites-ui',
  initialState: {
    ...baseUiInitialState,
  },
  reducers: {
    ...baseUiReducers,
  },
});
